import '~/js/modules/fend';
import Cookie from '~/js/modules/Cookie';

if(!Cookie.has('ALREADY_SUBSCRIBED')) {
    $('#footer-form-container').show();
}

const internals = {
    formSubmitted() {
        const $form = $('.footer-form');
        const $thankyouMessage = $('.thank-you-message-wrapper');

        $form.slideUp('fast');
        $thankyouMessage.slideDown('fast');
        document.cookie = 'ALREADY_SUBSCRIBED=true; Path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT;';
    }
};

// create new array for countries and appending a new object that represents default value
const countries = [
    {
        country: 'Please Select',
        countryId: '',
        regionCode: '',
        countryCode: ''
    },
    ...window.sandals_app.page.countries
];

// create new array for states and appending a new object that represents default value
const states = (window.sandals_app.page.states ? [
    ...window.sandals_app.page.states
] : []);

// react form components
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';


ReactDOM.render(
    <CountryStateSelector
        countries={ countries }
        states={ states }
        countryName="country"
        stateName="state"
        stateLabelWrapper="col-sm-3 hide"
        stateInputWrapper="col-sm-9 hide"
        countryLabelWrapper="col-sm-3"
        countryLabel="Select Country"
        countryInputWrapper="col-sm-9"
        isStateRequired={false}
    />,
    document.getElementById('country-state-selector')
);


// Form Validation
$('.footer-form').fend({
    customBehaviorAfterSuccess: internals.formSubmitted,
    rules: {
        firstName: 'lettersOnly'
    }
});

// form elements references
const $countrySelector = $('select[name="country"]');
const $subscribeLabel = $('.form-label[for="subscribe"]');

$subscribeLabel.text($subscribeLabel.data('normal'));

$countrySelector.on('change', (event) => {
    const countryId = event.target.value;

    $subscribeLabel.text($subscribeLabel.data('normal'));

    if (countryId === 'CA') {
        $subscribeLabel.html($subscribeLabel.data('canada'));
    }
});
